import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '@app/core/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { AbstractComponent } from '@app/shared/component/AbstractComponent';
import { Season } from '../../model/season.model';
import { SeasonService } from '../../service/season.service';

@Component({
  selector: 'app-coordinated-season-data-list',
  templateUrl: './coordinated-season-data-list.component.html',
  styleUrls: ['./coordinated-season-data-list.component.scss']
})
export class CoordinatedSeasonDataListComponent extends AbstractComponent implements OnInit {

  @Input() appId: string;            // si va a mostrar el nombre o no
  seasons: Array<Season> = [];

  constructor(
    private seasonService: SeasonService,
    public authService: AuthService,
    public translate: TranslateService/* ,
    private changeDetection: ChangeDetectorRef*/
  ) {
    super(authService, translate);
  }

  ngOnInit(): void {
    this.seasonService.findAll(false).subscribe(
      (seasons: Array<Season>) => {
        this.seasons = seasons;
        // this.changeDetection.detectChanges();
      }
    );
  }
}
